import { useNavigate } from 'react-router-dom'
import { api } from '../data/api'
import { Turno, TurnoStatus } from '../data/types/turnos.type'
import { formatDateToString, formatHourWithoutSeconds, formatStringToUserFullDate } from '../helpers/dates.helper'
import { LinkInApp } from './LinkInApp.component'

interface TurnoCardProps {
	turno: Turno
}

const cardStyle: React.CSSProperties = {
	border: '1px solid #e2e8f0',
	borderRadius: '8px',
	padding: '16px',
	marginBottom: '16px',
	boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
	display: 'flex',
	flexDirection: 'column'
}

const rowDoubleStyle: React.CSSProperties = {
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	width: '100%',
}

const badgeStyle = (color: string): React.CSSProperties => ({
	backgroundColor: color,
	borderRadius: '8px',
	padding: '4px 8px',
	fontSize: '12px',
	fontWeight: 'bold',
	color: '#e2e8f0',
})

const Badge = ({ status }: { status: TurnoStatus }) => {

	switch (status) {
		case TurnoStatus.PENDIENTE:
			return <p style={badgeStyle('#0a7415')}>{'Confirmado'}</p>
		case TurnoStatus.IMPAGO:
			return <p style={badgeStyle('#94a11f')}>{'Falta Pago'}</p>
		case TurnoStatus.CANCELADO:
			return <p style={badgeStyle('#921919')}>{'Cancelado'}</p>
		case TurnoStatus.COMPLETADO:
			return <p style={badgeStyle('#10217c')}>{'Completado'}</p>
		default:
			return null
	}
}

export const TurnoCard = ({ turno }: TurnoCardProps) => {
	const navigate = useNavigate()

	const handleAuthorizeClick = async () => {
		const response = await api.get(`/api/payments/generatePayment/${turno.id}`)
		window.open(response.data.paymentUrl, '_blank')
	}

	const handleProgramarOtroTurnoClick = () => {
		const params = new URLSearchParams({
			turnoId: String(turno.id),
			actionType: 'programar',
		})
		navigate({
			pathname: '/app/wizard',
			search: `?${params.toString()}`
		})
	}
	
	const handleCancelarTurnoClick = () => {
		navigate(`/app/cancelar-turno?turnoId=${turno.id}`)
	}

	const turnoEsHoy = () => {
		const today = formatDateToString(new Date())
		return turno.fecha === today
	}

	return (
		<div style={cardStyle}>
			<div style={rowDoubleStyle}>
				<p>{formatStringToUserFullDate(turno.fecha)}</p>
				<p>{formatHourWithoutSeconds(turno.hora)}</p>
			</div>
			<div>
				<p>
					{turno.medicoNombre}
					<br />
					({turno.especialidadNombre}) 
				</p>
			</div>
			<div style={rowDoubleStyle}>
				<p>${turno.tarifa}</p>
				<Badge status={turno.statusTurno as TurnoStatus} />
			</div>
			{turno.statusTurno === TurnoStatus.IMPAGO && (
				<p style={{ backgroundColor: '#d6d6d3', padding: '12px' }}>
					{`Si no paga el turno hoy, se cancelará automáticamente! `}
					<span 
						onClick = {handleAuthorizeClick}
						style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
					>
						{`Pagar ahora`}
					</span>
				</p>
			)}
			{(turno.statusTurno === TurnoStatus.PENDIENTE && !turnoEsHoy()) && (
				<LinkInApp 
					label='Puede Cancelar Turno hasta 24hs antes'
					onClick={() => {handleCancelarTurnoClick()}}
				/>
			)}
			{(turno.statusTurno === TurnoStatus.PENDIENTE && turnoEsHoy()) && (
				<LinkInApp 
					label='Abrir Videollamada'
					onClick={() => {window.open(turno.linkLlamada, '_blank')}}
				/>
			)}
			{/* {turno.statusTurno === TurnoStatus.COMPLETADO && (
				<p style={{textAlign: 'center'}}>
					<LinkInApp 
						label="Programar Otro Turno con este Médico" 
						onClick={() => {handleProgramarOtroTurnoClick()}} />
				</p>
			)} */}
		</div>
	)
}